<div class="modal-header"><h2 class="modal-title">Purchase</h2></div>
<div class="modal-body">
  @if (purchase) {
    <div class="m-2">
      <dx-form [formData]="purchase" validationGroup="mainValidationGroup">
        <dxi-item dataField="created" [label]="{ text: 'Date' }" [disabled]="true"></dxi-item>
        <dxi-item [label]="{ text: 'Paddle #' }">
          <div *dxTemplate>
            <dx-select-box
              [(value)]="purchase.auctionPaddleUserId"
              [dataSource]="auctionPaddleInfos"
              valueExpr="paddleUserId"
              displayExpr="displayName"
              [searchEnabled]="true"
            ></dx-select-box>
          </div>
          <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="'1'" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Item' }">
          <div *dxTemplate>
            <dx-select-box
              [(value)]="purchase.auctionItemId"
              [dataSource]="auctionItems"
              valueExpr="id"
              displayExpr="displayName"
              [searchEnabled]="true"
              [showClearButton]="true"
              (onValueChanged)="itemChanged($event)"
            ></dx-select-box>
          </div>
          <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="'1'" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="quantity" [label]="{ text: 'Quantity' }">
          <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="'0.01'" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="amount" [label]="{ text: 'Amount' }" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0, disabled: auctionItem?.type === 'Raffle Line' }">
          <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="'0.01'" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-success" (click)="save()">Save</button>
  <button class="btn btn-primary" (click)="close()">Close</button>
</div>
